import { SET_CLOSE_POPUP, SET_OPEN_POPUP } from "@jumbo/constants/ActionTypes";

export const setOpenPopupInfoAccount = () => {
  return { type: SET_OPEN_POPUP }
};
export const setClosePopupInfoAccount = () => {
  return { type: SET_CLOSE_POPUP }
};
